import { StationOwnerHistory } from './station-owner-history.model';
import { TranslateService } from '@ngx-translate/core';

export class StationOwnerHistoryModal {
  StationName: string;
  Amount: string;
  Currency: string;
  DateTime: string;
  Description: string;

  constructor(
    private stationOwnerHistory: StationOwnerHistory,
    private translate: TranslateService
  ) {
    this.StationName = stationOwnerHistory.StationName;

    this.Amount = (
      (stationOwnerHistory.PriceConsumption || 0) +
      (stationOwnerHistory.PriceParkingTime || 0) +
      (stationOwnerHistory.PricePenalty || 0)
    ).toFixed(2);
    this.Currency = stationOwnerHistory.PriceUnit;

    //the Z marks the date as UTC, it is parsed to a UNIX timestamp and created as a localized date
    const date = new Date(Date.parse(`${stationOwnerHistory.DateTime}Z`));
    this.DateTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;

    const descriptionDuration = (
      stationOwnerHistory.Durration / 3600.0
    ).toFixed(1);
    const descriptionConsumption = stationOwnerHistory.Consumption.toFixed(1);
    this.Description = `${descriptionDuration} h, ${descriptionConsumption} kWh`;
  }
}
